const TONE_FREQ_HZ = 1837;
const PULSE_ON_SEC = 0.045;
const PULSE_PERIOD_SEC = 0.087;
const PULSES_PER_GROUP = 6;
const GROUPS_PER_CYCLE = 2;
const GROUP_GAP_SEC = 0.313;
const CYCLE_TAIL_SILENCE_SEC = 0.88;
const RAMP_SEC = 0.003;
const PEAK_GAIN = 0.25;

const PULSE_ONSETS_SEC = (() => {
    const onsets = [];
    let t = 0;
    for (let g = 0; g < GROUPS_PER_CYCLE; g++) {
        for (let n = 0; n < PULSES_PER_GROUP; n++) {
            onsets.push(t);
            t += PULSE_PERIOD_SEC;
        }
        if (g < GROUPS_PER_CYCLE - 1) t += GROUP_GAP_SEC - PULSE_PERIOD_SEC;
    }
    return onsets;
})();
const CYCLE_DURATION_SEC =
    PULSE_ONSETS_SEC[PULSE_ONSETS_SEC.length - 1] + PULSE_ON_SEC + CYCLE_TAIL_SILENCE_SEC;

let audioContext = null;
let oscillator = null;
let gainNode = null;
let scheduleTimeoutId = null;

const schedulePulse = (onsetTime) => {
    const g = gainNode.gain;
    g.setValueAtTime(0, onsetTime);
    g.linearRampToValueAtTime(PEAK_GAIN, onsetTime + RAMP_SEC);
    g.setValueAtTime(PEAK_GAIN, onsetTime + PULSE_ON_SEC - RAMP_SEC);
    g.linearRampToValueAtTime(0, onsetTime + PULSE_ON_SEC);
};

const scheduleCycle = () => {
    if (!audioContext) return;
    const cycleStart = audioContext.currentTime;
    PULSE_ONSETS_SEC.forEach((offset) => schedulePulse(cycleStart + offset));
    scheduleTimeoutId = setTimeout(scheduleCycle, CYCLE_DURATION_SEC * 1000);
};

export const startRingingTone = () => {
    if (audioContext) return;
    try {
        const AudioCtor = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtor) return;
        audioContext = new AudioCtor();
        if (audioContext.state === 'suspended') {
            audioContext.resume().catch(() => {
            });
        }

        gainNode = audioContext.createGain();
        gainNode.gain.value = 0;
        gainNode.connect(audioContext.destination);

        oscillator = audioContext.createOscillator();
        oscillator.type = 'sine';
        oscillator.frequency.value = TONE_FREQ_HZ;
        oscillator.connect(gainNode);
        oscillator.start();

        scheduleCycle();
    } catch (error) {
        console.warn('Failed to start ringing tone:', error.message);
        audioContext = null;
    }
};

export const stopRingingTone = () => {
    if (scheduleTimeoutId) {
        clearTimeout(scheduleTimeoutId);
        scheduleTimeoutId = null;
    }
    if (oscillator) {
        try {
            oscillator.stop();
            oscillator.disconnect();
        } catch (e) {
        }
        oscillator = null;
    }
    if (gainNode) {
        try {
            gainNode.disconnect();
        } catch (e) {
        }
        gainNode = null;
    }
    if (audioContext) {
        audioContext.close().catch((error) => {
            console.warn('Failed to close ringing audio context:', error.message);
        });
        audioContext = null;
    }
};